import { API, Auth } from "aws-amplify";
import { recalledFleets, withFleets } from "../withFleets";

export function reservationPagePath(resId, fleetCode, section) {
  const path = withFleets("/reservation/" + resId, fleetCode);
  if (!section) return path;
  const join = path.includes("?") ? "&" : "?";
  return path + join + "section=" + encodeURIComponent(section);
}

export function driverPagePath(driverId, fleetCode, section) {
  const path = withFleets("/user/" + driverId, fleetCode);
  if (!section) return path;
  const join = path.includes("?") ? "&" : "?";
  return path + join + "section=" + encodeURIComponent(section);
}

export function fleetFromLocation(search) {
  const params = new URLSearchParams(search || "");
  return params.get("fleets") || recalledFleets() || "";
}

export async function fetchStaffSummary({ fleetCode, driverId, resId }) {
  const session = await Auth.currentSession();
  const jwt = session.getAccessToken().getJwtToken();
  const queryStringParameters = {
    back_end: process.env.REACT_APP_BACKEND,
    jwt,
    api_endpoint: "api3:portal:staff_summary",
    request_type: "GET",
    fleet_code: fleetCode,
  };
  if (driverId) queryStringParameters.driverId = String(driverId);
  if (resId) queryStringParameters.resId = String(resId);
  return API.get("adminWebTools", "/ago", { queryStringParameters });
}

export async function fetchVehiclePage({ fleetCode, vehicleId }) {
  const session = await Auth.currentSession();
  const jwt = session.getAccessToken().getJwtToken();
  return API.get("adminWebTools", "/ago", { queryStringParameters: {
    back_end: process.env.REACT_APP_BACKEND,
    jwt,
    api_endpoint: "api3:portal:vehicle",
    request_type: "GET",
    fleet_code: fleetCode,
    vehicle_id: String(vehicleId),
  }});
}

export async function fetchVehicleLocation({ fleetCode, vehicleId }) {
  const session = await Auth.currentSession();
  const jwt = session.getAccessToken().getJwtToken();
  return API.get("adminWebTools", "/ago", { queryStringParameters: {
    back_end: process.env.REACT_APP_BACKEND,
    jwt,
    api_endpoint: "api3:portal:vehicle_location",
    request_type: "GET",
    fleet_code: fleetCode,
    vehicle_id: String(vehicleId),
  }});
}

export async function updateVehiclePage({ fleetCode, vehicleId, action, fields }) {
  const session = await Auth.currentSession();
  const jwt = session.getAccessToken().getJwtToken();
  return API.get("adminWebTools", "/ago", { queryStringParameters: {
    back_end: process.env.REACT_APP_BACKEND,
    jwt,
    api_endpoint: "api3:portal:vehicle_update",
    request_type: "POST",
    fleet_code: fleetCode,
    vehicle_id: String(vehicleId),
    action,
    ...(fields || {}),
  }});
}

export function money(value) {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  return number.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function platformState(row) {
  const verification = String((row && row.verification) || "").toLowerCase();
  const connection = String((row && row.connection) || "").toLowerCase();
  if (verification.includes("verif")) return "Verified";
  if (connection && connection !== "connected") return connection;
  if (!verification) return "Linked";
  return row.verification;
}
